import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  wrapper: {
    '& .ant-modal-header': {
      padding: '32px 20px 16px 60px',
    },

    '& .ant-modal-body': {
      padding: '0 60px',
    },
  },
  summary: {
    ...theme.typography.body2,
    color: theme.colors.bodyColor,
    marginBottom: 16,
  },
  originProperty: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: 16,
    paddingBottom: 16,
    paddingLeft: 24,
    paddingRight: 24,
    backgroundColor: theme.colors.gray2,
    marginBottom: 24,
  },
  propertyIcon: {
    width: 14,
    height: 14,
    fill: theme.colors.bodyColor,
    marginRight: 8,
  },
  originPropertySpan: {
    ...theme.typography.body3,
    color: theme.colors.bodyColor,
  },
  originPropertyName: {
    ...theme.typography.body2,
    color: theme.colors.bodyColor,
  },
  propertyLabel: {
    ...theme.typography.body2,
    color: theme.colors.titleColor,
    marginBottom: 12,
  },
  propertyContainer: {
    marginBottom: 12,
  },
  properties: {
    border: '1px solid rgba(0, 0, 0, 0.09)',
  },
  selected: {
    height: 48,
    paddingTop: 13,
    paddingLeft: 16,
    ...theme.typography.body2,
    color: theme.colors.titleColor,
    backgroundColor: theme.colors.blue1,
  },
  search: {
    padding: 12,
  },
  result: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },
  emptyResult: {
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 240,
  },
  radio: {
    display: 'block',
    height: 48,
    lineHeight: '48px',
    width: '100%',
    paddingLeft: 12,
    borderBottom: '1px solid rgba(0,0,0,0.06)',
  },
  selectedRadio: {
    backgroundColor: theme.colors.mainGreen1,
  },
  disabledRadio: {
    '&:hover': {
      cursor: 'not-allowed',
    },
  },
  pagination: {
    height: 64,
    lineHeight: '64px',
    textAlign: 'right',
  },
  notice: {
    margin: 0,
  },
  createPropertyBtn: {
    paddingLeft: 3,
    height: 22,
    marginBottom: 32,
  },
  okButton: {
    '& span': {
      fontWeight: '600 !important',
    },
  },
  cancelButton: {
    color: `${theme.colors.bodyColor} !important`,
    borderColor: `${theme.colors.gray5} !important`,
  },
}));

export default useStyles;
